import { getAudurApiClient } from '../../../utils/Utils'

interface InterestRateChartResponse {
	rateRange: {
		activeFrom: string
		interestRate: number
	}[]
}

interface InterestRateChartRequest {
	from_date: string
	interest_type: 'Fixed' | 'Floating' | 'CentralBank7DayTermDeposits' | 'None'
}

export const getInterestRateChartData = async (params: InterestRateChartRequest) => {
	const client = getAudurApiClient()

	try {
		const response = await client.axiosInstance.get<InterestRateChartResponse>(`/mortgages/interest-rates/historical`, {
			params,
		})
		return response.data
	} catch (error) {
		console.error('Error fetching interest rate chart data:', error)
	}

	return null
}
